import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OAuthService } from 'angular-oauth2-oidc';
import { firstValueFrom } from 'rxjs';
import { DataService } from '../data.service';

/**
 *  KÖZÖSSÉGI SZOLGÁLAT – szülői és tanulói nézet.
 *
 *  Az érettségihez 50 óra kell. A gondviselő MINDEN gyermekét egyszerre látja (egy kártya
 *  gyermekenként – nincs mit választani), a tanuló a sajátját. A 9. évfolyam alatt a
 *  szolgálat még nem kezdődött: ott ezt mondjuk, nem egy üres, piros „0 / 50"-et.
 */

interface CsaladiIkszTetel {
  id: string;
  kezdete: string;
  vege: string;
  oraszam: number;
  tipus: string;
  teljesitesi_hely: string | null;
  megjegyzes: string | null;
}

interface CsaladiIkszKartya {
  oktazon: string;
  nev: string;
  osztaly: string;
  evfolyam: number | null;
  toltodik: boolean;
  hiba: string;
  ora: number;
  cel: number;
  teljesitve: boolean;
  hianyzik: number;
  tetelek: CsaladiIkszTetel[];
}

@Component({
  selector: 'app-szuloi-iksz',
  templateUrl: './szuloi-iksz.component.html',
  styleUrls: ['./szuloi-iksz.component.scss'],
})
export class SzuloiIkszComponent implements OnInit {
  intezmeny = '';
  toltodik = true;
  hiba = '';
  tanuloNezet = false;
  kartyak: CsaladiIkszKartya[] = [];

  constructor(private http: HttpClient, private oauth: OAuthService, private data: DataService) {}

  async ngOnInit() {
    try {
      await this.oauth.loadUserProfile();
    } catch { /* a kilét a tárolt adatból is feloldható */ }
    const user = this.data.belepoKilet(this.oauth.getIdentityClaims());
    const sajat = await this.data.getFromStorage('sajatIntezmeny');
    this.intezmeny = String(sajat?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
    if (!user?.username || !this.intezmeny) {
      this.hiba = 'Nem azonosítható a belépés vagy az intézmény.';
      this.toltodik = false;
      return;
    }
    try {
      const gyerekek: any[] = await firstValueFrom(this.http.get<any[]>(
        `/api/nyilvantartas/szulogyereke/${user.username}/${this.intezmeny}`)) || [];
      const sajatSor = this.data.sajatTanulo(gyerekek);
      this.tanuloNezet = !!sajatSor;
      //  A felügyeleti jogot nem gyakorló szülő (felugyeleti_jog jelölés) a közösségi szolgálatot nem látja.
      const lista = sajatSor ? [sajatSor] : gyerekek.filter((g) => g?.oktazon && !g?.felugyeleti_jog);
      this.kartyak = lista.map((g) => ({
        oktazon: String(g.oktazon),
        nev: g.full_name || g.name || String(g.oktazon),
        osztaly: g.aktualis_osztaly || g.osztaly || '',
        evfolyam: g.evfolyam != null && g.evfolyam !== '' ? Number(g.evfolyam) : null,
        toltodik: true, hiba: '', ora: 0, cel: 50, teljesitve: false, hianyzik: 50, tetelek: [],
      }));
    } catch (e: any) {
      this.hiba = e?.error?.error || 'Nem sikerült betölteni a tanulók listáját.';
    } finally {
      this.toltodik = false;
    }
    await Promise.all(this.kartyak.map((k) => this.kartyaBetolt(k)));
  }

  private async kartyaBetolt(k: CsaladiIkszKartya) {
    try {
      const r: any = await firstValueFrom(this.http.get(`/api/iksz/tanulo/${k.oktazon}/${this.intezmeny}`));
      Object.assign(k, {
        ora: Number(r?.ora) || 0, cel: Number(r?.cel) || 50, teljesitve: !!r?.teljesitve,
        hianyzik: Number(r?.hianyzik) || 0, tetelek: r?.tetelek || [],
      });
    } catch (e: any) {
      k.hiba = e?.error?.error || 'A közösségi szolgálat adatai nem tölthetők be.';
    } finally {
      k.toltodik = false;
    }
  }

  /** 9. évfolyam alatt, tétel nélkül: még nem kezdődött. */
  meg_nem_kezdodott(k: CsaladiIkszKartya): boolean {
    return k.evfolyam !== null && k.evfolyam < 9 && !k.tetelek.length;
  }

  szazalek(k: CsaladiIkszKartya): number {
    return Math.min(100, Math.round((k.ora / (k.cel || 50)) * 100));
  }

  ora(n: number): string {
    return Number.isInteger(n) ? String(n) : n.toLocaleString('hu-HU', { maximumFractionDigits: 1 });
  }

  idoszak(x: CsaladiIkszTetel): string {
    const f = (d: string) => d.replace(/-/g, '. ') + '.';
    return !x.vege || x.vege === x.kezdete ? f(x.kezdete) : `${f(x.kezdete)} – ${f(x.vege)}`;
  }
}
